// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonMap_wrapper__LuSh1","map":"SkeletonMap_map__qV9uL","map__top":"SkeletonMap_map__top__PPDiC","map__bottom":"SkeletonMap_map__bottom__NlWbh"};